import { createSelector } from "reselect";

import { selectCompetitorsSlice } from "app/pages/sales-intelligence/modules/company-analysis/store/selectors";
import type { TableRowKey } from "app/pages/sales-intelligence/modules/leads-search";
import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";

const select = createStatePropertySelector(selectCompetitorsSlice);

export const selectIsCompetitorsRowsSelectionEnabled = select("isRowSelectionEnabled");
const selectSelectedCompetitorsRows = select("selectedRows");
const selectFilteredCompetitorsRows = select("filteredRows");

export const selectSelectedCompetitorsRowKeys = createSelector(
    [selectSelectedCompetitorsRows],
    (selectedRows) => (selectedRows.map((row) => row.key) ?? []) as TableRowKey[],
);

export const selectSelectedCompetitorsDomains = createSelector([selectSelectedCompetitorsRows], (selectedRows) =>
    selectedRows.map((row) => row.domain),
);
export const selectFilteredCompetitorsDomains = createSelector([selectFilteredCompetitorsRows], (filteredRows) =>
    filteredRows.map((row) => row.domain),
);
